// extracted by mini-css-extract-plugin
module.exports = {"image-wrap":"AnalyticsAndKpiView_image-wrap__3_WVn","image":"AnalyticsAndKpiView_image__39-B-"};